import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import { tenantApi, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Loader2 } from "lucide-react";

export default function AdminOverview() {
  const { user } = useAuth();
  const [subscription, setSubscription] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.tenantId) return;
    tenantApi
      .get(`/tenants/${user.tenantId}/subscription`)
      .then((res) => setSubscription(res.data))
      .catch((err) => { const m = errorMessage(err); if (m) setError(m); })
      .finally(() => setLoading(false));
  }, [user]);

  return (
    <Layout variant="tenant">
      <h1 className="font-heading text-2xl font-bold">Overview</h1>
      <p className="mt-1 text-muted-foreground">Your workspace at a glance.</p>

      {loading && <Loader2 className="mt-8 h-6 w-6 animate-spin text-primary" />}
      {error && <p className="mt-8 text-sm text-destructive" data-testid="admin-overview-error">{error}</p>}

      {subscription && (
        <div className="mt-6 grid gap-4 sm:grid-cols-3">
          <Card>
            <CardHeader>
              <CardDescription>Plan</CardDescription>
              <CardTitle className="capitalize">{subscription.plan_code}</CardTitle>
            </CardHeader>
            <CardContent>
              <Badge variant={subscription.status === "active" ? "success" : "secondary"} data-testid="subscription-status-badge">
                {subscription.status}
              </Badge>
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <CardDescription>Billing cycle</CardDescription>
              <CardTitle className="capitalize">{subscription.billing_cycle}</CardTitle>
            </CardHeader>
          </Card>
          <Card>
            <CardHeader>
              <CardDescription>Renews</CardDescription>
              <CardTitle>{new Date(subscription.current_period_end).toLocaleDateString()}</CardTitle>
            </CardHeader>
          </Card>
        </div>
      )}
    </Layout>
  );
}
